<section class="wishlist-activity-feed" [attr.aria-label]="title()">
  <div class="activity-feed-header">
    <h2>{{ title() }}</h2>
  </div>

  @if (hasActivities()) {
    <ol class="activity-feed-list">
      @for (activity of activities(); track activity.id) {
        <li
          data-testid="wishlist-activity-item"
          class="activity-feed-item"
          [class.activity-feed-item-success]="activity.tone === 'success'"
          [class.activity-feed-item-warning]="activity.tone === 'warning'"
          [class.activity-feed-item-danger]="activity.tone === 'danger'"
          [class.activity-feed-item-info]="activity.tone === 'info'"
        >
          <span class="activity-marker" aria-hidden="true">
            {{ activity.iconLabel }}
          </span>
          <span class="activity-copy">
            <strong>{{ activity.title }}</strong>
            <span>{{ activity.description }}</span>
            <small>{{ activity.meta }}</small>
          </span>
          @if (activity.statusLabel !== null) {
            <span class="activity-status">{{ activity.statusLabel }}</span>
          }
        </li>
      }
    </ol>
  } @else {
    <p class="empty-state">{{ emptyText() }}</p>
  }
</section>
